import sergoShopImg from "../../assets/images/portfolio/Page/projects/p7.jpg";
import inappBlogImg from "../../assets/images/portfolio/Page/projects/p6.jpg";
import zlsLimoImg from "../../assets/images/portfolio/Page/projects/p1.jpg";
import atenkNewYearImg from "../../assets/images/portfolio/Page/projects/p2.jpg";
import nersessianBlogImg from "../../assets/images/portfolio/Page/projects/p3.jpg";
import nersessianLawImg from "../../assets/images/portfolio/Page/projects/p4.jpg";
import politicalImg from "../../assets/images/portfolio/Page/projects/p5.jpg";

const portfolioData = [
  {
    image: sergoShopImg,
    name: "Sergo Shop",
    link: "https://sergoshop-inapp.netlify.com/collections/all",
  },
  {
    image: inappBlogImg,
    name: "InApp Blog",
    link: "https://www.inappblog.com/",
  },
  {
    image: zlsLimoImg,
    name: "ZLS Limousine Service",
    link: "https://zls-inapp.netlify.com/",
  },
  {
    image: atenkNewYearImg,
    name: "Atenk New Year Shopping",
    link: "https://newyearatenk-inapp.netlify.com/",
  },
  {
    image: nersessianBlogImg,
    name: "Nersessian Blog",
    link: "https://www.nersessianlawfirm.com/blog/",
  },
  {
    image: nersessianLawImg,
    name: "Nersessian Law Firm",
    link: "https://www.nersessianlawfirm.com/",
  },
  {
    image: politicalImg,
    name: "Political Dialogue",
    link: "https://political.am/",
  },
];

export default portfolioData;
